import { render, staticRenderFns } from "./ReportThaiTax.vue?vue&type=template&id=6b8547ec&scoped=true"
import script from "./ReportThaiTax.vue?vue&type=script&lang=js"
export * from "./ReportThaiTax.vue?vue&type=script&lang=js"
import style0 from "./ReportThaiTax.vue?vue&type=style&index=0&id=6b8547ec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8547ec",
  null
  
)

export default component.exports